(function (angular, schoolwork12) {
    'use strict';
    var fulfillmentApprovalapp = angular.module(schoolwork12.app.fulfillmentApproval.name);

    fulfillmentApprovalapp.controller(schoolwork12.app.fulfillmentApproval.controllers.fulfillmentApproval, ['$rootScope'
        , '$scope', '$timeout', schoolwork12.app.auth.services.authentication,
        schoolwork12.app.common.services.eventNotification,'$http','uiGridConstants','$uibModal',
        function ($rootScope, $scope, $timeout, authentication, eventNotification,$http,uiGridConstants,$uibModal) {
            console.info("in fulfillment approval controller");            
            eventNotification.subscribe(schoolwork12.app.auth.events.userLoggedIn,
                function (event, authenticatedUser) {
                    console.info('StudentSearch: Subscribe On UserLogin Event: '
                        .concat(angular.toJson(authenticatedUser)));
                    $scope.schoollist = authenticatedUser.schools;
                });
            if (authentication.isAuthenticated()) {
                $scope.schoollist = authentication.getSchools();
            };
            $scope.fulfillmentSuccess = false;
            var studentCopy = angular.copy($scope.student);
            $scope.resetForm = function () {
                console.info("Resetting student search form..");                
                $scope.student = angular.copy(studentCopy);
                $scope.studentEligibilitySearchForm.$setPristine();
            };           
            $scope.modifyInputToCSV = function () {
                // Remove white spaces and new line
                // characters
                // convert input to comma separated string.
                var input = $scope.student.studentId;
                input = input.replace(/\n/g, " ").replace(
                    / +/g, " ").replace(/[ ,]+/g, ",");
                $scope.student.studentId = input;
            };
            var rowtpl='<div ng-class="grid.options.rowStyle(row)"><div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell></div></div>';
            $scope.gridOptions = {
                enableFiltering : true,
				enableGridMenu : true,
				exporterMenuPdf : false,
                paginationPageSizes : [ 25, 50, 75 ],
                paginationPageSize : 25,
                enableRowSelection : true,
                enableRowHeaderSelection : true,
                rowHeight: 50,
                showGridFooter : true,
                rowStyle: function(row){
                    if(row.isSelected){
                        if(typeof(row.entity.isEdited) != "undefined"){
                            if(row.entity.isEdited){
                                return 'fulfillmentRowsEdited';
                            }
                        } else {
                            return 'ui-grid-selected-row';
                        }                                              
                    }
                },
				rowTemplate:rowtpl,
                onRegisterApi : function(gridApi) {
										$scope.gridApi = gridApi;
										$scope.resizeGrid = {
										    'width' : 'auto',
                                            'margin-left' : '300px'
  										};
				},
                columnDefs : [
                    {
                       field : 'studentId',
                       displayName : "Student ID",
                    },
                    {
                        field : 'schoolId',
                        displayName : "School ID",
                    },
                    {
                        field : 'firstName',
                        displayName : "First Name",
                    },
                    {
                        field : 'lastName',
                        displayName : "Last Name",
                    },
                    {
                        field : 'gradelevel',
                        displayName : "Grade",
                    },
                    {
                        field : 'computerEligibility',
                        displayName : "Eligibility",
                    },
                    {
                        field : 'parentsChoice',
                        displayName : "Parents Choice",
                    },
                    {
                        field : 'approvalStatus',
                        displayName : "Approval Status",
                    },
                    {
                        field : 'farmStatus',
                        displayName : "FARM Status",
                    },
                    {
                        field : 'specialEd',
                        displayName : "Special Ed?",
                    },
                    {
                        field : 'familyId',
                        displayName : "Family ID",
                    },
                    {
                        field : 'reason',
                        displayName : "Reason",
                    },
                ],                
                gridMenuCustomItems : [
                    {
                        shown : function (){
                          return this.grid.api.selection && this.grid.api.selection.getSelectedRows().length > 0  
                        },
                        title : 'Approve Students',
                        order : 211,
                        action : function() {
                            $scope.approveStudents($scope.gridApi.selection.getSelectedRows());
                            //$scope.approveStudents($scope.gridApi);
                        }
                    },
                    {
                        shown : function (){
                          return this.grid.api.selection && this.grid.api.selection.getSelectedRows().length > 0  
                        },
                        title : 'Deny Students',
                        order : 212,
                        action : function() {
                            $scope.denyStudents($scope.gridApi.selection.getSelectedRows());
                        }
                    }
                ],
            };
            $scope.callStudentEligibilitySearchService = function () {               
                $scope.displayGrid = false;
                $scope.errorOccured = false;  
                $scope.ErrorMesg = "";
                $scope.validateStudentIdField();                
                if(! $scope.errorOccured){
                    $scope.isSearchBusy = true;										
                    $scope.isSearchDisabled = true;
                    $scope.fulfillmentSuccess = false;
                    var postData = {};                    
                    if($scope.student.firstName != null && $scope.student.firstName != ''){
                        postData.firstName =  $scope.student.firstName ;
                    }
                    if($scope.student.lastName != null && $scope.student.lastName != ''){
                        postData.lastName =  $scope.student.lastName ;
                    }
                    if ($scope.student.studentId != null && $scope.student.studentId != ""){
                        postData.studentIds = $scope.student.studentId.split(",");
                    }
                    if ($scope.student.grade != null && $scope.student.grade != ""){
                        postData.gradeLevels = $scope.student.grade;
                    }
                    postData.schoolIds = $scope.student.school;
                    if ($scope.student.familyId != null && $scope.student.familyId != ""){
                        postData.familyId = $scope.student.familyId;
                    }
                    if ($scope.student.eligibility != null && $scope.student.eligibility != ""){
                        postData.eligibility = $scope.student.eligibility;
                    }
                    if ($scope.student.approvalStatus != null && $scope.student.approvalStatus != ""){
                        postData.approvalStatus = $scope.student.approvalStatus;
                    }
                    if ($scope.student.parentsChoice != null && $scope.student.parentsChoice != ""){
                        postData.parentsChoice = $scope.student.parentsChoice;
                    }
                    $http({
                        
                        method : "POST",
				        url : schoolwork12.app.fulfillmentApproval.endpoints.getEligibleStudentList,
                        data : postData,
                        headers : {
                            'X-API-TOKEN' : authentication.getCurrentUser().keycode,
				        }
                        
                    }).then(function(response){                        
                        if(response.data.length > 0){
                            $scope.displayGrid = true;
                            //console.info(angular.toJson(response.data));
                            $scope.gridOptions.data = response.data;
                        }else {
                            $scope.errorOccured = true;
                            $scope.ErrorMesg = schoolwork12.app.errorMessages.noResultsFound;
                        }
                    }, function(error){
                        console.error('Error when getting the list of eligible students..'.concat(angular.toJson(error)));
                        $scope.errorOccured = true;
                        if (error.status == 400) {
                            for (var j = 0; j < error.data._errors.length; j++) {
                                $scope.ErrorMesg = $scope.ErrorMesg + error.data._errors[j] + "\n";
                            }
                        } else if (error.status == 401 || error.status == 403) {
                            $scope.ErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                        } else {
                            $scope.ErrorMesg = schoolwork12.app.errorMessages.internalError;
                        }                        
                    })['finally'](function(){
                        $scope.isSearchBusy = false;													
                        $scope.isSearchDisabled = false;
                    });                    
                }
            };
            $scope.validateStudentIdField = function () {
                if ($scope.student.studentId != null && $scope.student.studentId != "") {
                    var data = $scope.student.studentId
                        .split(",");
                    if (data.length < 500) {                        
                        for (var j = 0; j < data.length; j++) {                            
                            var numberMatcher = /^[0-9]+$/;
                            if (data[j] != "") {
                                if (!data[j]
                                    .match(numberMatcher)) {                                   
                                    $scope.errorOccured = true;
                                    $scope.ErrorMesg = schoolwork12.app.fulfillmentApproval.errorMessages.studentIdNumeric;
                                    break;
                                }
                            }
                        }
                    } else {                       
                        $scope.errorOccured = true;
                        $scope.ErrorMesg = schoolwork12.app.fulfillmentApproval.errorMessages.studentIds500;
                    }
                }
            };
            $scope.approveStudents = function(studentList){
                //console.info(angular.toJson(studentList));
                $scope.errorOccured = false;
                $scope.fulfillmentSuccess = false;
                if($scope.validateSelectedFields(studentList,1)){                    
                    $scope.openModel(studentList,1);
                } else {
                    $scope.errorOccured = true;
                    //$scope.ErrorMesg = schoolwork12.app.fulfillmentApproval.errorMessages.parentsDeclinedInSearch;
                }                               
            };
            $scope.denyStudents = function(studentList){
                $scope.errorOccured = false;
                $scope.fulfillmentSuccess = false;
                if($scope.validateSelectedFields(studentList,0)){
                    $scope.openModel(studentList,0);
                 } else {
                    $scope.errorOccured = true;                    
                } 
            };
            $scope.validateSelectedFields = function(studentList,actionType){
              for(var i=0; i< studentList.length; i++){
                  if(studentList[i].parentsChoice == "Declined"){
                	  $scope.ErrorMesg = schoolwork12.app.fulfillmentApproval.errorMessages.parentsDeclinedInSearch;
                      return false;                      
                  }
                  if(studentList[i].approvalStatus == "N/A - Cannot Be Overridden"){
                  	  $scope.ErrorMesg = schoolwork12.app.fulfillmentApproval.errorMessages.cannotOverrideStudentsInSearch;
                      return false;                      
                  }else if(studentList[i].approvalStatus == "Approved" || studentList[i].approvalStatus == "Approved by School"){
                	  if(actionType == 1){ 			//--Approve
                		  $scope.ErrorMesg = schoolwork12.app.fulfillmentApproval.errorMessages.approveApprovedStudentsInSearch;
                          return false;  
                	  }else if (actionType == 0){ 	//--Deny
                		  $scope.ErrorMesg = schoolwork12.app.fulfillmentApproval.errorMessages.approvedStudentsInSearch;
                          return false;    
                	  }
                  }else if(studentList[i].approvalStatus == "Denied" || studentList[i].approvalStatus == "Denied by School"){
                	  if(actionType == 0){ 			//--Deny
                		  $scope.ErrorMesg = schoolwork12.app.fulfillmentApproval.errorMessages.denyDeniedStudentsInSearch;
                          return false;     
                	  }
                  }
              }
              return true;
            };
            $scope.openModel = function(studentList,value){
                $scope.fulfillmentSuccess = false;
                var modalInstance = $uibModal.open({
                    templateUrl: schoolwork12.app.fulfillmentApproval.templates.fulfillmentApprovalModal,
                    size: 'md',
                    controller: ['$scope', '$uibModalInstance', 'studentList', 'value', 'authentication', function ($scope, $uibModalInstance, studentList, value
                                                                                                                     , authentiction) {     
                        //console.info(angular.toJson(studentList));
                        $scope.isApproval = false;
                        $scope.isDenial = false;
                        if(value == 1){
                            $scope.isApproval = true;                           
                        } else if(value == 0){
                             $scope.isDenial = true;
                        };
                        $scope.cancel = function () {
                            $uibModalInstance.dismiss('cancel');
                        };
                        $scope.save = function(){
                            $scope.disableSubmit = true;
                            $scope.errorOccuredInModal = false;
                            $scope.ErrorMesgInModal ='';
                            //console.info($scope.studentApproval);
                            var data={};
                            data.reason = $scope.studentApproval.reason;
                            if($scope.studentApproval.notes != null && $scope.studentApproval.notes != ''){
                                data.notes = $scope.studentApproval.notes;
                            }
                            if(value == 1){
                                data.actionType = true;
                            } else if(value == 0){
                                data.actionType = false;
                            }
                            var studentApprovalList = [];                           
                            for(var i=0; i< studentList.length; i++){
                                var studentApprovalObject = {};
                                studentApprovalObject.schoolId = studentList[i].schoolId;
                                studentApprovalObject.approvalStatus = studentList[i].approvalStatus;
                                studentApprovalObject.studentId = studentList[i].studentId;
                                studentApprovalObject.computerEligibility = studentList[i].computerEligibility;
                                studentApprovalObject.pcid = studentList[i].pcid;
                                studentApprovalList.push(studentApprovalObject);
                            };
                            data.studentApprovalList = studentApprovalList;
                            //console.info(angular.toJson(data));
                            $http({
                        
                                    method : "POST",
                                    url : schoolwork12.app.fulfillmentApproval.endpoints.saveEligibleStudentList,
                                    data : data,
                                    headers : {
                                            'X-API-TOKEN' : authentication.getCurrentUser().keycode,
				                    }
                        
                            }).then(function(response){
                                console.info(response.data);
                                $scope.disableSubmit = true;
                                $scope.updateSuccess = true;
                                //console.info("....."+angular.toJson(data));
                                $uibModalInstance.close(data);
                                $scope.successMessage = response.data;
                        }, function(error){
                            console.error('Error when getting the bundle types....'.concat(angular.toJson(error)));
                             $scope.disableSubmit = false;
                            $scope.errorOccuredInModal = true;
                            if (error.status == 400) {
                                for (var j = 0; j < error.data._errors.length; j++) {
                                 $scope.ErrorMesgInModal = $scope.ErrorMesgInModal + error.data._errors[j] + "\n";
                                }
                            } else if (error.status == 401 || error.status == 403) {
                                $scope.ErrorMesgInModal = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.ErrorMesgInModal = schoolwork12.app.errorMessages.internalError;
                            }                        
                        })['finally'](function(){
                           // $scope.disableSubmit = false;
                        }); 
                            
                        };
                    }],
                    resolve: {
                        studentList: function () {
                            return studentList;
                        },
                        value: function () {
                            return value;
                        }
                    }
                });
                modalInstance.result.then(function (data) {                    
                    $scope.fulfillmentSuccess = true;                                   
                    $scope.FulfillmentSuccessMesg = schoolwork12.app.fulfillmentApproval.editMessages.fulfillmentSuccessMesg;
                    for(var i =0; i< $scope.gridApi.selection.getSelectedRows().length; i++){
                    	var eligibilityStatus = $scope.gridApi.selection.getSelectedRows()[i].computerEligibility;
                        if(data.actionType){ 
                        	$scope.gridApi.selection.getSelectedRows()[i].approvalStatus = "Approved by School";
                        } else {
                        	$scope.gridApi.selection.getSelectedRows()[i].approvalStatus = "Denied by School";
                        }
                        $scope.gridApi.selection.getSelectedRows()[i].isEdited = true;
                        $scope.gridApi.selection.getSelectedRows()[i].reason = data.reason;                        
                    }
				});
            };
        }
    ]);

}(angular, schoolwork12));